<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow"
            >mdi-reload</v-icon
          >
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox
            class="no-display"
            v-model="registration_no"
            @change="checkHistory"
            :loading="comp_load"
            rounded
            :items="stud_list"
            label="Select Student"
            item-text="name"
            outlined
            dense
            prepend-icon="mdi-account-child-circle"
          ></v-combobox>
        </v-col>
        <!-- <v-btn class="button mt-4" v-if="registration_no != null" @click="checkHistory()">Proceed</v-btn> -->
      </v-row>
      <!-- new code -->
      <div v-if="registration_no != null">
        <!-- collapse table code -->
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table
                  :headers="headers_1"
                  :items="ay_record"
                  class="elevation-1 mytable"
                  dense
                >
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table
                  :headers="headers_2"
                  :items="ay_record_div"
                  dense
                  class="elevation-1 mytable"
                >
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- tableData -- <br>{{ay_record}} -->
        <!-- collapse table code end -->
        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group
            v-model="fetch_gen_toggle"
            mandatory
            row
            class="radiobtn"
          >
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <!-- {{ ay_record }}<br /> -->
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50"
              >Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
      <!-- end dd -->
    </v-card>

    <template v-if="registration_no != null">
      <!-- shiv code -->

      <!-- shiv code end -->

      <!-- FGT:{{ fetch_gen_toggle }} -->

      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <!-- <v-row justify="center">
           <v-col cols="12" sm="4" md="4" class="mt-3">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  dense
                  v-model="last_date_of_school"
                  @blur="date = parseDate(last_date_of_school)"
                  v-on="on"
                  hint="Last Date of Leaving"
                  prepend-icon="event"
                  persistent-hint
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col> 
          <v-col cols="12" sm="3" md="3" class="mt-3">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  dense
                  v-model="application_date"
                  @blur="date = parseDate(application_date)"
                  v-on="on"
                  hint="Date Of Application"
                  prepend-icon="event"
                  persistent-hint
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_of_application"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row> -->
        <!-- Date ends -->
        <!-- L:{{ last_date_of_school }} -->
        <v-row justify="center" class="mt-3">
          <!-- <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="progress"
              rounded
              :items="dvt_prog"
              label="Select Progress"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col> -->
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="conduct"
              rounded
              :items="dvt_conduct"
              label="Select Conduct"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <!-- <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="remark"
              rounded
              :items="dvt_remark"
              label="Select Remark"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col> -->
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="reason"
              rounded
              :items="dvt_reason"
              label="Select Reason"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="whether_failed_remark"
              rounded
              :items="whether_failed_remarks"
              label="Select Whether Failed Remark"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="mt-3">
            <v-text-field
              label="Whether NCC Cadet/Boy Scout/ Girl Guide"
              v-model.trim="whether_ncc_cadet"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="other_activity"
              rounded
              :items="other_activities"
              label="Select Other Activity"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col> -->
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="extra_curricular_activity"
              rounded
              :items="extra_curricular_activities"
              label="Select  Extra Curriculat Activity"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
        </v-row>
         <v-row justify="center" class="mt-3">
           <v-checkbox
            color="#0f2027"
            v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"
          ></v-checkbox>
         </v-row>
         <v-row justify="center">
          <v-btn @click="genLC">Generate LC</v-btn>
         </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <!-- <v-btn
          v-if="lc_data != null"
          class="ma-2 no-display"
          tile
          outlined
          color="warning"
          @click="print()"
        >
          <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
        </v-btn> -->

        <br />
      </template>
      <template v-if="lc_data != null">
        <!-- lc data-- {{ lc_data }} <br /><br />
        org data--{{ org_basic_data }} <br /><br /> -->
        <!-- lc data code -->
        <div id="document1" class="printdiv">
          <div class="header">
            <v-row dense>
              <v-col cols="12" sm="2" md="2">
                <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
                <!-- <span
                  class="b-sapn"
                  style="font-weight: 500; margin-left: 18px; font-size: 11px"
                >
                  UDISE No: {{ lc_data.udise_no }}
                </span> -->
              </v-col>

              <v-col cols="12" sm="10" md="10">
                <center>
                  <h3 class="trust-name">{{ org_basic_data.trust_name }}</h3>
                  <h1 class="schl-name">{{ org_basic_data.school_name }}</h1>

                  <!-- <h3 style="text-transform: uppercase">(English Medium)</h3> -->
                </center>
                <center>
                  <span class="adrs">
                    CBSE Affiliated and NABET Accredited
                  </span>
                </center>
                <center>
                  <span class="adrs"
                    >Address:&nbsp;{{ org_basic_data.address }}</span
                  ><br />

                  <span class="adrs">
                    Contact No.:&nbsp;{{ org_basic_data.phone }}
                  </span>
                  <span class="adrs" style="margin-left: 5px">
                    <v-icon left color="black">mdi-email-outline</v-icon>
                    {{ org_basic_data.email }} </span
                  ><br />
                  <span class="adrs">www.sbpatilschool.org</span>
                </center>
                <!-- <center>
                  <span class="line1" v-html="org_basic_data.line1"></span
                  ><br />

                  <span class="line2" v-html="org_basic_data.line2"></span
                  ><br />
                </center> -->
                <br />
                <div class="lcheading1">
                  <h3 class="stretch2">
                    School Leaving / Transfer Certificate
                  </h3>
                </div>
                <br>
                <center>
                  <p style="font-size: 17px">(No change in any entry in this certificate shall be made except by the authority issuing it and
                   infringement of this requirement is liable to invoice the imposition of penalty such as that of rustication)</p>
                </center>
              </v-col>
            </v-row>
          </div>

          <div class="lcdata">
            <v-col cols="12">
              <v-row dense style="font-weight: bolder">
                <v-col cols="12" md="4" sm="4">
                  Affiliation No.:&nbsp;{{ lc_data.Affiliation_no }}
                </v-col>
                <v-col cols="12" md="4" sm="4"></v-col>
                <v-col align="right" cols="12" md="4" sm="4"
                  >UDISE No.:&nbsp;{{ lc_data.udise_no }}</v-col
                >
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row dense style="font-weight: bolder">
                <v-col cols="12" md="4" sm="4">
                  Sr. No.:&nbsp;{{ lc_data.certificate_no }}
                </v-col>
                <v-col cols="12" md="4" sm="4" align="center"
                  >GR No.:{{ lc_data.gr_number }}</v-col
                >
                <v-col align="right" cols="12" md="4" sm="4"
                  >School Code:&nbsp; {{ lc_data.school_code }}</v-col
                >
              </v-row>
            </v-col>

            <!-- lc table content  -->

            <v-col cols="12" sm="12" md="12">
              <v-simple-table id="page">
                <tbody class="tablebody">
                  <tr>
                    <td>1.</td>
                    <td style="width: 50%">Name of the Pupil</td>
                    <td class="tdata2">
                      <span> :&nbsp;{{ lc_data.fullname }}</span>
                    </td>
                  </tr>

                  <tr>
                    <td>2.</td>
                    <td>Mother's Name</td>
                    <td class="tdata2">
                      :&nbsp;{{ lc_data.mother_first_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>3.</td>
                    <td>Father's/Guardian's Name</td>
                    <td class="tdata2">:&nbsp;{{ lc_data.father_name }}</td>
                  </tr>
                  <tr>
                    <td>4.</td>
                    <td>Nationality</td>
                    <td class="tdata2">:&nbsp;{{ lc_data.nationality }}</td>
                  </tr>
                  <tr>
                    <td>5.</td>
                    <td>
                      Whether the candidate belongs to Schedule Caste or
                      Schedule Tribe or OBC
                    </td>
                    <td class="tdata2">
                      :&nbsp;{{ lc_data.religion }}
                      <span v-if="lc_data.caste != null && lc_data.caste != ''">- {{ lc_data.caste }}</span><span v-else> </span>
                      <span v-if="lc_data.sub_caste"> - {{ lc_data.sub_caste }}</span>
                      <span v-if="lc_data.actualcategory">
                        &nbsp;&nbsp; ({{ lc_data.actualcategory }})
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>6.</td>
                    <td>Date of first Admission in the School with class</td>
                    <td class="tdata2">
                      :&nbsp;{{ lc_data.doa_edit }}&nbsp;&nbsp;&nbsp;<span
                        v-if="lc_data.admitted_standard"
                      >
                        (&nbsp;{{ lc_data.admitted_standard }}&nbsp;)</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>7.</td>
                    <td>
                      Date of Birth According to Admission and Withdrawal
                      Register
                    </td>
                    <td class="tdata2">
                      :&nbsp;(in Figures) - {{ lc_data.dob_fig }}
                    </td>
                    <!-- <td class="tdata2">:(in Words){{ lc_data.dob_words }}</td> -->
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <!-- <td class="tdata2">:(in Figures){{ lc_data.dob_fig }}</td> -->
                    <td class="tdata2">
                      :&nbsp;(in Words) - {{ lc_data.dob_words }}
                    </td>
                  </tr>
                  <tr>
                    <td>8.</td>
                    <td>Class in which the pupil last studied</td>
                    <td class="tdata2">
                      :&nbsp;(in Figures) -
                      {{ lc_data.standard }}&nbsp;&nbsp;(in Words) -
                      {{ lc_data.std_in_words }}
                    </td>
                  </tr>
                  <tr>
                    <td>9.</td>
                    <td>
                      School/Board Annual examination last taken with result
                    </td>
                    <td class="tdata2">:&nbsp;{{ lc_data.last_school }}</td>
                  </tr>
                  <tr>
                    <td>10.</td>
                    <td>
                      Whether failed, if so, once / twice in the same class
                    </td>
                    <td class="tdata2">
                      :&nbsp; {{ Whether_failed_in_same_class }}
                    </td>
                  </tr>
                  <tr>
                    <td>11.</td>
                    <td>Subjects Studied</td>
                    <td class="tdata2">
                      <!-- :&nbsp;{{ lc_data.courses }} -->
                      <ul
                        style="list-style-type: none"
                        v-for="(course_name, index) in lc_data.courses"
                        :key="index"
                      >
                        <li style="float: left; padding-right: 16px">
                          {{ index + 1 }})
                          {{ course_name.course_name }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>12.</td>
                    <td>
                      Whether qualified for promotion to the higher class?
                      <br />
                      If so, to which class
                    </td>
                    <td class="tdata2">
                      <span v-if="is_promoted_to_next_standard">
                        :&nbsp; {{ is_promoted_to_next_standard.name }}<br
                      /></span>
                      <span v-if="is_promoted_to_next_standard.name === 'Yes'">
                        :&nbsp;(in Figures): -
                        {{ promoted_standard.standard }}&nbsp;&nbsp;&nbsp;(in
                        Words) - {{ promoted_standard_in_words }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>13.</td>
                    <td>Month up to which the pupil has paid school dues</td>
                    <td class="tdata2">:&nbsp;{{ lc_data.receipt_date }}</td>
                  </tr>
                  <tr>
                    <td>14.</td>
                    <td>
                      Any fee concession availed of. if so, the nature of such
                      concession
                    </td>
                    <td class="tdata2">:&nbsp;{{ lc_data.concession }}</td>
                  </tr>
                  <tr>
                    <td>15.</td>
                    <td>
                      Total number of working days in the academic session
                    </td>
                    <td class="tdata2">
                      :&nbsp;
                      {{ lc_data.total_working_days_sem }}
                    </td>
                  </tr>
                  <tr>
                    <td>16.</td>
                    <td>
                      Total number of working days pupil present in the school
                      <br />
                      (details may be given)
                    </td>
                    <td class="tdata2">
                      :&nbsp; {{ lc_data.student_present_days }}
                    </td>
                  </tr>
                  <tr>
                    <td>17.</td>
                    <td>Whether NCC Cadet/Boy Scout/ Girl Guide</td>
                    <td class="tdata2">:&nbsp; {{ whether_ncc_cadet }}</td>
                  </tr>
                  <tr>
                    <td>18.</td>
                    <td>
                      Games played or extra-curricular activities in which the
                      pupil usually took part (mention achievement level
                      therein):.
                    </td>
                    <td class="tdata2">
                      :&nbsp;{{ lc_data.extra_curricular_activities }}
                    </td>
                  </tr>
                  <tr>
                    <td>19.</td>
                    <td>General Conduct</td>
                    <td class="tdata2">:&nbsp;{{ lc_data.conduct }}</td>
                  </tr>
                  <tr>
                    <td>20.</td>
                    <td>Date of application for this certificate</td>
                    <td class="tdata2">
                      :&nbsp;{{ lc_data.date_of_application }}
                    </td>
                  </tr>
                  <tr>
                    <td>21.</td>
                    <td>Date of issue of this certificate</td>
                    <td class="tdata2">:&nbsp;{{ lc_data.date_of_issue }}</td>
                  </tr>
                  <tr>
                    <td>22.</td>
                    <td>Reason for leaving the school</td>
                    <td class="tdata2">:&nbsp;{{ lc_data.reason }}</td>
                  </tr>
                  <tr>
                    <td>23.</td>
                    <td>Any other remark</td>
                    <td class="tdata2">
                      :&nbsp;{{ lc_data.any_other_remark }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <!-- lc table end -->
            <!-- <span style="margin-left: 15%"
              >Certified that the above information is in accordance with the
              School Register </span
            ><br />
            <span class="tdata2" style="margin-left: 5px"
              >Date :- {{ last_date_of_school }}</span>
               -->
            <v-col cols="12" style="font-weight: bolder">
              <v-row dense>
                <v-col cols="12" md="4" sm="4"> Prepared By </v-col>
                <v-col cols="12" md="4" sm="4">
                  <center>
                    <span>Checked By</span><br />
                    <span>(with full Name & Designation)</span>
                  </center>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <center>
                    <!-- {{ org_basic_data.school_name }}<br /> -->
                    <span>Signature of Principal</span> <br />
                    <span>(with Date & School Seal)</span>
                  </center>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </div>
        <!-- lc data code end -->

        <br />
        <span v-if="fetch_gen_toggle == 'FETCH'">
          <div class="no-display" style="text-align: center">
            ----------------------------------Modify------------------------------------
          </div>
          <br />
          <v-card class="box">
            <v-row class="no-display">
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  label="Name of the Pupil"
                  v-model.trim="lc_data.fullname"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  label="Birth in words"
                  v-model.trim="lc_data.dob_words"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  label="Last School"
                  v-model.trim="lc_data.last_school"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  label="Standard"
                  v-model.trim="lc_data.standard"
                ></v-text-field>
              </v-col>

              <!-- <v-col cols="12" sm="2" md="3">
            <v-text-field
              label="Since when..."
              v-model.trim="lc_data.standard_since_when"
            ></v-text-field>
          </v-col> -->

              <v-col cols="12" sm="3" md="3" class="mt-3">
                <v-text-field
                  label="Any Other Remark"
                  v-model="lc_data.any_other_remark"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <p>Is Promoted To Next Standard</p>
                <v-combobox
                  v-model="is_promoted_to_next_standard"
                  rounded
                  :items="is_promoted_to_standard"
                  label="Select Option"
                  item-value="name"
                  item-text="name"
                  @change="setnextstandard(is_promoted_to_next_standard)"
                  outlined
                  dense
                  persistent-hint
                ></v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="3"
                v-if="show_promoted_standards == true"
              >
                <p>Select Standard To Which Student Will Promoted</p>
                <v-combobox
                  v-model="promoted_standard"
                  rounded
                  :items="standard_list"
                  label="Select Standard"
                  item-value="standard"
                  item-text="standard"
                  outlined
                  dense
                  persistent-hint
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="mt-3">
                <v-text-field
                  label="Month up to which the pupil has paid school dues	"
                  v-model.trim="lc_data.receipt_date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="mt-3">
                <v-text-field
                  label="Whether NCC Cadet/Boy Scout/ Girl Guide"
                  v-model.trim="whether_ncc_cadet"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="2" md="2" class="mt-3">
                <v-text-field
                  label="Date Of First Admission In The School"
                  v-model.trim="lc_data.doa_edit"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="2" md="2" class="mt-3">
                <v-text-field
                  label="First Admitted Standard In The School"
                  v-model.trim="lc_data.admitted_standard"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="mt-3">
                <v-text-field
                  label="Whether failed, once / twice in the same class	"
                  v-model.trim="Whether_failed_in_same_class"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="mt-3">
                <v-text-field
                  label="Games played or extra-curricular activities in which the pupil usually took part (mention achievement level therein)"
                  v-model.trim="lc_data.extra_curricular_activities"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="2" md="2">
              <v-text-field
                label="Total Working Days"
                v-model.trim="
                  lc_data.learner_attendance[0].total_working_days_sem
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-text-field
                label="Total Present Days"
                v-model.trim="lc_data.learner_attendance[0].present"
              ></v-text-field>
            </v-col> -->
            </v-row>
            <center>
              <b>Note:-&nbsp;</b
              ><span
                >For Admission Date and Standard please use Edit Student Profile
                link.</span
              >
            </center>
          </v-card>

          <div class="no-display" style="text-align: center">
            ----------------------------------Update------------------------------------
          </div>
          <v-card class="box">
            <v-row class="no-display">
              <v-col cols="12" sm="2" md="2">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-bind="attrs"
                      dense
                      v-model="date_of_generation"
                      @blur="date = parseDate(date_of_generation)"
                      v-on="on"
                      hint="LC Generation Date"
                      prepend-icon="event"
                      persistent-hint
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="gen_date"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-bind="attrs"
                      dense
                      v-model="application_date"
                      v-on="on"
                      hint="Date Of Application"
                      prepend-icon="event"
                      persistent-hint
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_of_application"
                    no-title
                    @input="menu2 = false"
                    @change="setToText()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-menu
                  ref="menu2"
                  v-model="menu3"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-bind="attrs"
                      dense
                      v-model="issue_date"
                      v-on="on"
                      hint="Date Of Issue"
                      prepend-icon="event"
                      persistent-hint
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    label="Issue Date"
                    v-model="date_of_issue"
                    no-title
                    @input="menu3 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  type="text"
                  label="Total Working Days"
                  v-model.trim="lc_data.total_working_days_sem"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  type="text"
                  label="Total Present Days"
                  v-model.trim="lc_data.student_present_days"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-row justify="center" class="no-display">
            <v-col cols="12" sm="3" md="3">
              <v-btn
                class="mb-2 button"
                color="warning"
                @click="savegenLC()"
                small
                >Save</v-btn
              >
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <center>
                <v-btn @click="proceed" class="info">
                  <v-icon left color="black">mdi-printer</v-icon>Proceed to
                  print</v-btn
                >
              </center>
            </v-col>
          </v-row>
        </span>
      </template>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      mark_inactive:false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      //////date
      last_date_of_school: "",
      date_of_generation: "",
      application_date: "",
      issue_date: "",
      date: new Date().toISOString().substr(0, 10),
      gen_date: new Date().toISOString().substr(0, 10),
      date_of_application: new Date().toISOString().substr(0, 10),
      date_of_issue: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      org_basic_data: null,
      whether_failed_remarks: [],
      whether_failed_remark: "",
      other_activities: [],
      other_activity: "",
      extra_curricular_activities: [],
      extra_curricular_activity: "",
      any_other_remark: "",
      standard_list: [],
      promoted_standard: "",
      is_promoted_to_standard: [
        { name: "Yes", id: "1" },
        { name: "No", id: "2" },
        { name: "Essential Repeat", id: "3" },
      ],
      is_promoted_to_next_standard: "",
      show_promoted_standards: false,
      promoted_standard_in_words: "",
      whether_ncc_cadet: "",
      Whether_failed_in_same_class: "",
    };
  },
  watch: {
    gen_date(val) {
      this.date_of_generation = this.formatDate(this.gen_date);
    },
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
      this.lc_data.date_of_application = this.application_date;
    },
    date_of_issue(val) {
      this.issue_date = this.formatDate(this.date_of_issue);
    },
  },
  methods: {
    setToText() {
      this.lc_data.date_of_application = this.application_date;
    },
    proceed() {
      console.log("is", this.is_promoted_to_next_standard.name);
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem(
        "org_basic_data",
        JSON.stringify(this.org_basic_data)
      );
      localStorage.setItem(
        "is_promoted_to_next_standard",
        JSON.stringify(this.is_promoted_to_next_standard)
      );
      localStorage.setItem(
        "Whether_failed_in_same_class",
        JSON.stringify(this.Whether_failed_in_same_class)
      );
      // is_promoted_to_next_standard
      let routeData = this.$router.resolve({ name: "sbpps-lc-print" });
      window.open(routeData.href, "_blank");
    },
    setnextstandard(item) {
     //  alert("item::"+item.name)
      if (item.name == "Yes") {
        this.show_promoted_standards = true;
        this.promoted_standard = this.lc_data.nextstandard;
        this.promoted_standard_in_words = this.lc_data.next_std_in_words;
      } else {
        this.show_promoted_standards = false;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },

    // row_classes(item) {
    //     console.log("in function row");
    //     const rowClass = 'redrow'
    //     if (item.status === "pending" )
    //     return rowClass
    //     if(item.status === "clear")
    //     return "green"

    // },

    //     row_classes: function (item) {
    //         console.log("in fu");
    //     return item.status === 'pending' ? 'style-1' : 'style-2'

    // },

    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res");
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_reason[0];

            this.other_activities = res.data.other_activities;
            this.whether_failed_remarks = res.data.whether_failed_remarks;
            this.extra_curricular_activities = res.data.extra_curricular_activities;
            this.other_activity = this.other_activities[0];
            this.whether_failed_remark = this.whether_failed_remarks[0];
            this.extra_curricular_activity =this.extra_curricular_activities[0];
            this.standard_list = res.data.standard_list;

            //this.any_other_remark=res.data.any_other_remark
            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    savegenLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To Generate LC As Fees Is Pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        // this.last_date_of_school != "" &&
        this.remark != null &&
        this.reason != null
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          // last_date_of_school: this.last_date_of_school,
          gen_date: this.date_of_generation,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          whether_failed_remark: this.whether_failed_remark,
          other_activity: this.whether_ncc_cadet,
          extra_curricular_activity: this.lc_data.extra_curricular_activities,
          any_other_remark: this.any_other_remark,
          total_working_days_sem: this.lc_data.total_working_days_sem,
          total_present_days: this.lc_data.student_present_days,
          mark_inactive:this.mark_inactive
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              this.lc_data.last_school = this.org_basic_data.school_name;
              this.showSnackbar("green", "Success..!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To Generate LC As Fees Is Pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        // this.last_date_of_school != "" &&
        this.remark != null &&
        this.reason != null
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          // last_date_of_school: this.last_date_of_school,
          gen_date: this.date_of_generation,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          whether_failed_remark: this.whether_failed_remark,
          other_activity: this.whether_ncc_cadet,
          extra_curricular_activity: this.extra_curricular_activity,
          any_other_remark: this.any_other_remark,
          mark_inactive:this.mark_inactive
          // total_working_days_sem:this.lc_data.total_working_days_sem,
          // total_present_days:this.lc_data.student_present_days
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              this.lc_data.last_school = this.org_basic_data.school_name;
              this.showSnackbar("green", "Success..!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            if(this.lc_data.extra_curricular_activities){
              this.extra_curricular_activity=this.lc_data.extra_curricular_activities
            }
            this.lc_data.last_school = this.org_basic_data.school_name;
            this.date_of_application = this.formatDate(
              this.lc_data.date_of_application
            );
            this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);
            this.gen_date = this.formatDate(this.lc_data.cert_date);
            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.date_of_generation = this.formatDate(this.gen_date);
    this.application_date = this.formatDate(this.date_of_application);
    this.issue_date = this.formatDate(this.date_of_issue);
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}
.mytable1 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
/* tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
} */
/* @media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
} */
/* v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: medium;
} */

.expapanel {
  width: 93%;
  margin-left: 3%;
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3792c7,
    #60e3eb,
    #a0dfe3
  ); /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}

.fees span {
  font-size: 23px;
  font-weight: 600;
}

/* .radiobtn{
  display: inline !important;
} */

/* lc data css */
.printdiv {
  border: 3px solid;
  border-color: black;
  height: auto;
  /* width: 944px; */
  /* margin-left: 5%; */
  /* margin-top: 5px; */
  width: auto;
  margin-left: 5%;
  margin-right: 5%;
}
.header {
  /* border:2px solid;  */
  margin: 6px;
}
.trust-name {
  /* margin-left: 22%; */
  text-transform: uppercase;
  font-size: x-large;
}
.schl-name {
  font-size: 30px;
  text-transform: uppercase;
  font-size: xxx-large;
}

.adrs {
  margin-left: 33px;
  font-size: larger;
  font-weight: 500;
}

/* .line1 {
        margin-left: 15px;
    }
    .line2 {
        margin-left: 22px;
    } */

.stdsection {
  margin-left: 30%;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 15px;
}

.b-sapn {
  display: block;
  margin-top: 2px;
}

.lcheading {
  /* border-block: 1px solid black; */
  border: 1px solid black;

  /* display: block; */
  /* width: 26%; */
  /* border-left: 1px solid black; */
  /* border-right: 1px solid black; */
  /* margin-left: 30%; */
  font-size: 17px;
  font-weight: 600;
  padding-left: 5px;
  padding-right: 5px;
  text-transform: uppercase;
}

.lcheading1 {
  margin-left: 16%;
  width: 65%;
  /* text-align: center; */
  border-radius: 17px;
  border: 1px solid black;
}

.lcheading1 h3 {
  font-size: xx-large;
  margin-left: 18px;
  font-family: Segoe Print;
  font-style: italic;
}
.schlImg {
  /* width: 196px;
        height: 196px; */
  width: 87%;
  height: 60%;
  margin-left: 10px;
}
.tdata2 {
  font-weight: bolder;
}

#page tr,
td {
  /* padding: 0;  */
  /* margin-left: 0px; */
  font-size: medium;
  text-align: left;
}
/* lc data css end */

/* print lc css */
@media print {
  .card {
    border: none !important;
    font-size: large !important;
  }
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  /* img {
            width: 100% !important;
        } */
  body,
  tr,
  th,
  td {
    font-size: large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 13.5in 20.5in;

    /* size: 13in 18in; */
  }

  thead {
    font-weight: bold !important;
  }
  table,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }
}
/* print lc css end */
.redrow {
  background-color: red !important;
  color: red;
}

.style-1 {
  background-color: rgb(215, 84, 44);
  font-weight: bolder;
}
.style-2 {
  background-color: rgb(61, 219, 21);
}
span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}
.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}
</style>
